// extracted by mini-css-extract-plugin
export default {"container":"backArrow_container__4ekXE","icon":"backArrow_icon__4CRnY"};